module.exports = __webpack_public_path__ + "static/img/popular.9787fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/popular.png
// module id = E5tx
// module chunks = 1